import React, { useMemo } from 'react';
import { isMultiHcKoshIntegrationEnabled } from 'feature-flags';
import { RouteComponent, Router } from 'react-resource-router';
import { PROJECT_NAME } from 'routes/common/constants';
import { viewHelpCentersManagementPageRoute } from 'routes/help-centers-management';
import { GlobalStyled } from 'view/styles/global';
import { history } from '@atlassian/help-center-common-util/history';
import { getCloudId, getHelpCenterAri, getWorkspaceAri } from '@atlassian/help-center-common-util/meta';
import { notFoundErrorRoute } from '../routes';

export const HelpCentersManagementResourceRouter = () => {
    //Order matters here
    const routes = useMemo(
        () => [...(isMultiHcKoshIntegrationEnabled() ? [viewHelpCentersManagementPageRoute] : []), notFoundErrorRoute],
        []
    );
    const customContext = {
        cloudId: getCloudId(),
        productName: PROJECT_NAME,
        helpCenterAri: getHelpCenterAri(),
        workspaceAri: getWorkspaceAri(),
    };

    //isGlobal=false, to avoid the router conflicting with the sidebar's router.
    return (
        <Router routes={routes} history={history} isGlobal={false} resourceContext={customContext}>
            <GlobalStyled />
            <RouteComponent />
        </Router>
    );
};

export default HelpCentersManagementResourceRouter;
